import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { CampanhaFilter } from '../../filter';
import { CampanhaResultado } from '../campanha-resultado';

@Injectable({
    providedIn: 'root'
})
export class CampanhaResultadoHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/campanha`;
    }

    /** Carrega o resultado de uma campanha */
    load(idCampanha: number, filter: CampanhaFilter): Observable<CampanhaResultado> {
        let params = new HttpParams();

        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<CampanhaResultado>(`${this.pathApi}/${idCampanha}/resultado`, {params});
    }
}
